import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// ALL PAGE ROUTES
import routes from "./routes";
// REDUX STORE
import { store } from "./redux/Store";
// FAKE DB
import "../fake-db";
import { useEffect } from "react";
import { initializeActivityTracking } from "./services/activityTracker";


// REACT_APP_BASEURL = "https://pms.belinnov.co.in" test
export default function App() {
  useEffect(() => { initializeActivityTracking(routes); }, []);
  return (
    <Provider store={store}>
      <RouterProvider router={routes} />
      <ToastContainer />
    </Provider>
  );
}
